import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeCanChange = async ({ docId, canChange }) => {
  return await request.put(
    `/Docs/can_change/${docId}?canChange=${canChange}`,
    null,
    'При изменении возможности редактирования произошла ошибка',
    'Error'
  );
};

const useChangeCanChange = () =>
  useMutation(changeCanChange, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

export default useChangeCanChange;
